import request from '@/utils/request'

export function getList (filters = {}, pagination = {}) {
  return request({
    url: '/adverse_event_has_treatment',
    method: 'get',
    headers: {
      'X-filters': JSON.stringify(filters),
      'X-pagination': JSON.stringify(pagination)
    }
  })
}

export function getDetail (data) {
  return request({
    url: '/adverse_event_has_treatment/' + data.adverse_event_id + '/' + data.treatment_id,
    method: 'get'
  })
}

export function upsert (data, isNew=false) {
  const method = isNew ? 'post' : 'put'
  const url = isNew ? '/adverse_event_has_treatment' : `/adverse_event_has_treatment/${data.adverse_event_id}_${data.treatment_id}`
  return request({
    url,
    method,
    data
  })
}

export function remove (data) {
  return request({
    url: '/adverse_event_has_treatment/' + data.adverse_event_id + '/' + data.treatment_id,
    method: 'delete'
  })
}
